// extracted by mini-css-extract-plugin
export var attachment = "_oz-a";
export var emailContainer = "_oz-4";
export var emailContentPaddedContainer = "_oz-b";
export var emailHeader = "_oz-6";
export var emailIframe = "_oz-3";
export var emailInfoIcon = "_oz-9";
export var emailShortenedSummary = "_oz-e";
export var infoDropdown = "_oz-0";
export var infoRowBoundedContent = "_oz-d";
export var internal = "_oz-5";
export var merchant = "_oz-8";
export var messageInputContainer = "_oz-h";
export var normal = "_oz-7";
export var replyCard = "_oz-f";
export var subtleButton = "_oz-1";
export var subtleButtonIconContainer = "_oz-2";
export var toggleViewRepliesButton = "_oz-c";
export var wrappingText = "_oz-g";